export default __webpack_public_path__ + "static/6-7628dd878ff39a02ad941b1b3cff7760.png";